import { type ClerkLocalization } from '@/auth/clerk/types/ClerkLocalization';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Clerk's translation of its own screens for the active language, loaded by
// activateLocale together with ours. Undefined: Clerk's built-in English.
export const clerkBaseLocalizationState = createAtomState<
  ClerkLocalization | undefined
>({
  key: 'clerkBaseLocalizationState',
  defaultValue: undefined,
});
